import * as React from 'react';
import { Link } from 'react-router-dom';
import { ListItem } from '@material-ui/core';

const SubLink = (p: any) => {
  const { ...other } = p;
  return <Link {...other} />;
};

export default (props: any) => <ListItem {...props} component={SubLink} />;



// WEBPACK FOOTER //
// ./src/components/LinkListItem.tsx